"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMultiScalpingV2Parameters = void 0;
const types_1 = require("../types");
const isMultiScalpingV2Parameters = (x) => x.method === types_1.Method.MultiScalpingV2;
exports.isMultiScalpingV2Parameters = isMultiScalpingV2Parameters;
